import type { Translate, TKey } from '@/i18n/translate';

export const achievementTitle = (t: Translate, id: string) => t(`achievements.${id}.title` as TKey);
export const achievementDescription = (t: Translate, id: string) =>
  t(`achievements.${id}.description` as TKey);
